import ls from '../../../../services/securels'
import { API } from "../../../api-config"


export const getVortexProducts = async (access_token) => {

  const token = ls.get("token")



  return await fetch(`${API}/vortex/products`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
      "access_token": `${access_token}`,
    },

  })
    .then((response) => {
      return response
    })
    .catch((err) => {

      return err
    })
}


export const getVortexProduct = async (product = '') => {

  return await fetch(`${API}/vortex/product/${product}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }
  }).then(async response => {
    let result = await response.json()
    return result
  }).catch(err => {
    return err
  })
}